// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"block_searchWrapper__d3BsU"};